import React from 'react';
import { Grid, Typography, Box } from '@mui/material';

const ProcedureMedia = ({ nodeId, media = [] }) => {
    const images = (media ?? []).filter((m) => m.mediaType === 'Image' && m.url);

    if (images.length === 0) return null;

    return (
        <Box mt={3} sx={{ pageBreakInside: 'avoid' }}>
            <Typography variant="subtitle1" gutterBottom sx={{ mb: 2, fontWeight: 500 }}>
                Image Attachments
            </Typography>

            <Grid container spacing={3}>
                {images.map((img) => (
                    <Grid item xs={12} key={img.mediaId}>
                        <Box
                            sx={{
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 2,
                                p: 2,
                            }}
                        >
                            <Box
                                component="img"
                                src={img.url}
                                alt={img.displayName ?? `media-${img.mediaId}`}
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    borderRadius: 1,
                                    mb: 1.5,
                                }}
                            />

                            <Typography variant="body2" color="text.secondary">
                                {img.displayName ?? `media-${img.mediaId}`}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export { ProcedureMedia };
